import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChrome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={21}
    height={20}
    fill='none'
    {...props}
  >
    <rect width={19} height={19} x={1.3} y={0.5} fill='url(#chrome_svg__a)' rx={9.5} />
    <defs>
      <pattern id='chrome_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#chrome_svg__b' transform='scale(.00417)' />
      </pattern>
      <image
        xlinkHref='/images/icons/chrome-c30066ef.webp'
        id='chrome_svg__b'
        width={240}
        height={240}
      />
    </defs>
  </svg>
);
export default SvgChrome;
